import { render, staticRenderFns } from "./PlatinumMembershipTier.vue?vue&type=template&id=b609f0f2&"
import script from "./PlatinumMembershipTier.vue?vue&type=script&lang=ts&"
export * from "./PlatinumMembershipTier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports